import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5915f496"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "flex-m",
  style: {"justify-content":"space-between"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Start Date:", -1))
const _hoisted_3 = {
  class: "flex-m",
  style: {"justify-content":"space-between"}
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "End Date:", -1))
const _hoisted_5 = {
  class: "flex-m",
  style: {"justify-content":"space-between"}
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Maximum Number:", -1))
const _hoisted_7 = {
  class: "flex-m",
  style: {"justify-content":"space-between"}
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Goal:", -1))
const _hoisted_9 = {
  key: 0,
  class: "flex-m",
  style: {"justify-content":"space-between"}
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Reward:", -1))
const _hoisted_11 = { style: {"display":"grid","text-align":"end"} }
const _hoisted_12 = { style: {"font-size":"12px"} }
const _hoisted_13 = {
  key: 1,
  class: "text-end"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("p", null, _toDisplayString(_ctx.$dayjs(_ctx.campaignInfo?.startDate).format("DD/MM/YYYY") || "-"), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("p", null, _toDisplayString(_ctx.$dayjs(_ctx.campaignInfo?.endDate).format("DD/MM/YYYY") || "-"), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("p", null, _toDisplayString(_ctx.addComma(_ctx.campaignInfo?.completeCount || "0")) + "/" + _toDisplayString(_ctx.addComma(_ctx.campaignInfo?.maximumNumber || "0")), 1)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("p", null, _toDisplayString(_ctx.capitalize(_ctx.campaignInfo?.action || "-")), 1)
    ]),
    _createElementVNode("div", null, [
      (_ctx.campaignInfo?.reward.type === 'PERCENT')
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("p", null, _toDisplayString(_ctx.campaignInfo?.reward.amountPercent) + "% of payment", 1),
              _createElementVNode("p", _hoisted_12, " (Maximum " + _toDisplayString(_ctx.campaignInfo?.reward.amountPercentMaxPerTime) + " THB, Minimum " + _toDisplayString(_ctx.campaignInfo?.reward.amountPercentMinPerTime) + " THB) ", 1)
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("p", null, _toDisplayString(_ctx.campaignInfo?.reward.amountPerTime) + " THB Per Action", 1)
          ]))
    ])
  ], 64))
}